import React from "react"
import "./Modal.scss"
import Button from "../../component/button/button"

interface ConfirmModalProps {
  isOpen: boolean
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  onConfirm: () => void
  onCancel: () => void
  isLoading?: boolean
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  if (!isOpen) return null

  return (
    <div
      className="modal-backdrop"
      onClick={(event) => {
        if (event.target === event.currentTarget && !isLoading) {
          onCancel()
        }
      }}
    >
      <div
        className="modal confirm-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
      >
        <div className="modal-header">
          <h2 id="confirm-modal-title">{title}</h2>
        </div>
        <div className="modal-body">
          <p className="confirm-modal__message">{message}</p>
        </div>
        <div className="modal-footer confirm-modal__footer">
          <Button
            text={cancelLabel}
            type="secondary"
            buttonType="button"
            disabled={isLoading}
            onClick={onCancel}
            style={{ height: 40 }}
          />
          <Button
            text={confirmLabel}
            type="primary"
            buttonType="button"
            disabled={isLoading}
            isLoading={isLoading}
            onClick={onConfirm}
            style={{ height: 40 }}
          />
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
